module.exports = __webpack_public_path__ + "static/img/01_user_value.96b3b6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/01_user_value.png
// module id = McFB
// module chunks = 176